import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { StepResult } from '../../catalog-modal.component';

@Component({
  selector: 'itpx-main-step',
  templateUrl: './main-step.component.html',
  styleUrls: ['./main-step.component.css']
})
export class MainStepComponent implements OnInit {
  @Input() name: string;
  @Input() stepdata: any[];
  @Input() subtitle: string = '';
  @Input() catalogHeaders: string[] = [];


  @Output() saveFinished = new EventEmitter<StepResult>()

  // marketplaceCatalogs;
  // customCatalogs;
  catalogs: any[][] = [];
  constructor(private smartModalService: SmartModalService) { }

  ngOnInit() {
    if (this.stepdata) {
      this.catalogs.push(this.stepdata.filter(m => !m.domainSpecific));
      this.catalogs.push(this.stepdata.filter(m => m.domainSpecific));
    }
  }
  private onTileClicked(e: any) {
    this.saveFinished.emit({ id: e.code, title: e.name } as StepResult)
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/catalog-modal/steps/main-step/main-step.component.ts